import { CSSObject, Theme } from '@core-ui/react-stitch';

const getFocusStyle = (theme: Theme): CSSObject => ({
  animation: 'none',
  outline: 'solid',
  outlineColor: theme.color.b1,
  outlineWidth: 'thin'
});

export default getFocusStyle;
